import { ISharedConfig, setDialog, setSession, setSnackbar } from '@shared/library';
import axios from 'axios';
import React, { JSX } from 'react';
//#region COMPONENTS
import { Fade } from '@mui/material';
import AdministrationPanel from '@optisewer/administration-panel';
import DistrictMetering from '@optisewer/district-metering';
import Home from '@optisewer/home';
import OperationsDashboard from '@optisewer/operations-dashboard';
import WastewaterQualityDashboard from '@optisewer/wastewater-quality-dashboard';
import WastewaterQualitySamplings from '@optisewer/wastewater-quality-samplings';
import GestDialog from '@shared/library/dist/components/gest/GestDialog/GestDialog';
import GestSnackbar from '@shared/library/dist/components/gest/GestSnackbar/GestSnackbar';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
//#endregion
//CONTEXTS
import { config } from '../../../../static/config';
import { CntxConfig } from '../../../Optisewer';
//MODELS
import { MenuArea_model } from '../../../../models/ui_data/MenuArea_model';
//STATIC
import { firstPathSegment } from '../../../../static/methods';

const ROUTE_MODULES: Record<string, (cntxConfig: ISharedConfig) => JSX.Element> = {
    "": cntxConfig => <Home {...cntxConfig} />,
    "districts": cntxConfig => <DistrictMetering {...cntxConfig} />,
    "operations": cntxConfig => <OperationsDashboard {...cntxConfig} />,
    "quality/dashboard": cntxConfig => <WastewaterQualityDashboard {...cntxConfig} />,
    "quality/samplings": cntxConfig => <WastewaterQualitySamplings {...cntxConfig} />,
};

interface ContentProps {
    menu: MenuArea_model[];
    menuLoaded: boolean;
}

const Content = ({ menu, menuLoaded }: ContentProps) => {
    //CONTEXTS USE
    const cntxConfig = React.useContext(CntxConfig)!;

    //STATIC DATA
    const routerLocation = useLocation();

    //STATES
    const [inProp, setInProp] = React.useState(true);
    const pollingLoading = React.useRef(false);

    //#region METHODS

    //#region API CALLS
    const checkPollingStatus = (endpoint: "Auth/SessionValid" | `Gest/Software/${string}/frontend/${string}/${string}/IsChanged`) =>
        axios.get<{ token: string; }>(`${config.api.internal}/${endpoint}`, { withCredentials: true })
            .then(res => Boolean(res.data.token))
            .catch((err) => err.status !== 401);

    const doPollingChecks = () => setInterval(async () => {
        if (!pollingLoading.current) {
            pollingLoading.current = true;
            //check session
            const isLoggedIn = await checkPollingStatus("Auth/SessionValid");

            if (!isLoggedIn) {
                setSnackbar(cntxConfig, { message: "Sessione scaduta. Ritorno alla login in corso...", severity: "error" });
                setTimeout(() => setSession(cntxConfig), 3_000);
            }
            else {
                //check version
            }

            pollingLoading.current = false;
        }
    }, 60_000);//1 minute
    //#endregion

    //#region STATES CHANGE
    React.useEffect(() => {
        let interval: NodeJS.Timeout | undefined;

        if (cntxConfig.session?.userData) {
            interval = doPollingChecks();
        }

        return () => clearInterval(interval);
    }, [cntxConfig.session?.userData]);

    React.useEffect(() => {
        setInProp(false);
        const timeout = setTimeout(() => setInProp(true), 500);
        return () => clearTimeout(timeout);
    }, [routerLocation]);
    //#endregion

    return cntxConfig?.session &&
        <Fade in={inProp} timeout={400}>
            <div className="pages">
                {menuLoaded &&
                    <Routes>
                        {menu
                            .flatMap(area => area.subs)
                            .filter(option => option.enabled)
                            .map(option => {
                                const fullPath = option.path.replace(/^\//, '');
                                const element = ROUTE_MODULES[fullPath] ?? ROUTE_MODULES[firstPathSegment(option.path)];
                                return element ? <Route key={option.id} path={option.path} element={element(cntxConfig)} /> : null;
                            })
                        }

                        {cntxConfig.session?.userData?.role.toLowerCase() === "superadmin" &&
                            <Route path="/administration-panel" element={<AdministrationPanel {...cntxConfig} />} />}

                        <Route path="*" element={<Navigate to={"/"} />} />
                    </Routes>
                }

                <GestSnackbar {...cntxConfig} />
                <GestDialog {...{ ...cntxConfig.dialog, setModal: dialog => setDialog(cntxConfig, dialog) }} />
            </div >
        </Fade>;
};
export default React.memo(Content);